import { Component, Input } from '@angular/core';
import { StatusTransfer } from '@toro/common/shared/enum/finance/status-transfer.enum';

@Component({
    selector: 'app-withdrawal-history-item-icon',
    templateUrl: './withdrawal-history-item-icon.html',
    styleUrls: ['./withdrawal-history-item-icon.scss']
})

export class WithdrawalHistoryItemIconComponent {
    @Input() public transferStatus: StatusTransfer;

    public readonly status = StatusTransfer;
}
